import ApiService from '../api.services';

const DriverActionService = {
  list: async function() {
    try {
      const response = await ApiService.get('/api/driver-actions');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async function(id) {
    try {
      const response = await ApiService.get(`/api/driver-actions/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  add: async function(form) {
    try {
      const data = {
        action: form,
      };
      const res = await ApiService.post('/api/driver-actions', data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  update: async function(id, form) {
    const data = {
      action: form,
    };
    try {
      const response = await ApiService.put(`/api/driver-actions/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async function(id) {
    try {
      const response = await ApiService.delete(`/api/driver-actions/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default DriverActionService;

export { DriverActionService };
